import AddIcon from "@mui/icons-material/Add";
import CloseExpendIcon from "../../../icons/CloseExpendIcon"
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip
} from "@mui/material";
import { FC, ReactNode } from "react";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

interface ICategoryExpansionDialogProps {
  open: boolean;
  canEditCanvas: boolean;
  title: ReactNode;
  children: ReactNode;
  onAdd: () => void;
  onClose: () => void;
  isEditCanvas: boolean;
}

const CategoryExpansionDialog: FC<ICategoryExpansionDialogProps> = (props) => {
  const { open, children, title, onClose, onAdd, canEditCanvas, isEditCanvas } =
    props;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          onClose();
        } else if (reason === "escapeKeyDown" && !isEditCanvas) {
          onClose();
        }
      }}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          if (!isEditCanvas) onClose();
        }
      }}
    >
      <Box sx={{ bgcolor: "#F4F4F4" }}>
        <DialogTitle
          sx={{
            padding: "10px 14px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <Box component="strong" sx={{ fontSize: "1rem" }} className="text">
            {title}
          </Box>

          <Box
            component="strong"
            sx={{
              backgroundColor: "transparent",
              display: "flex",
              fontSize: "1rem",
              position: "absolute",
              top: 4,
              right: 3
            }}
            className="text"
          >
            {canEditCanvas && (
              <Tooltip
                title="Add Hypothesis"
                PopperProps={{
                  sx: {
                    zIndex: "1500 !important"
                  }
                }}
              >
                <IconButton aria-label="close" onClick={onAdd}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip
              title="Close"
              PopperProps={{
                sx: {
                  zIndex: "1500 !important"
                }
              }}
            >
              <IconButton aria-label="close" onClick={onClose}
                sx={{
                      p:"5px 10px",
                      mr:"4px",
                      svg: {
                      fontSize: "15px",
                  },
              }}
              >
                <CloseExpendIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </DialogTitle>

        <DialogContent
          sx={{
            width: "600px",
            minHeight: "100%",
            overflowY: "auto",
            padding: "0px 5px 25px 5px",
            paddingRight: -12,
            bgcolor: "transparent"
          }}
        >
          {children}
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default CategoryExpansionDialog;
